import React from "react";
import {Button, Drawer, Form, Input, Select, Spin} from "antd";
import {ContactGet, ContactList, ContactPost} from "../models/crm/contact";
import {Role, UserContext} from "../controller/Utils";

const Option = Select.Option;
const FormItem = Form.Item;
const { TextArea } = Input;
const _ = require('lodash');

class ContactFilterForm extends React.Component {
  static contextType = UserContext;
  state = {
    visible: false,
    data: [],
    value: [],
    fetching: false
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    this.setState({
      visible: false
    });
  };
  fetchContact = (value = '') => {
    this.setState({data: [], fetching: true});
    const requestData = {'search': value, 'active': true, 'bill_to': this.props.bill_to_id};
    ContactList(requestData)
      .then(body => {
        const data = body.data.results;
        this.setState({data, fetching: false});
      });
  };
  handleDrawerSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values['bill_to'] = this.props.bill_to_id;
        ContactPost(values)
          .then(response => {
            this.setState({
              visible: false,
              value: {key: response.id, label: `${response.first_name} ${response.last_name}`}
            });
            this.props.onChange(response.id);
          });
      }
    });
  };
  handleChange = value => {
    const {data} = this.state;
    let obj = null;
    this.setState({
      value,
      fetching: false
    });
    if(value && value.key){
      obj = _.find(data, function (d) {return d.id === Number(value.key)})
    }
    this.props.onChange(value.key, obj);
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { fetching, data, value } = this.state;
    return (
      <div>
        <div className="pos-relative">
          <Select labelInValue showSearch value={value} placeholder="Select Contact"
            notFoundContent={fetching ? <Spin size="small" /> : "Not Found"} filterOption={false}
            onFocus={this.fetchContact} onSearch={this.fetchContact} onChange={this.handleChange}
            style={{ width: "100%" }}>
            {data.map(d => (<Option key={d.id}>{ `${d.first_name} ${d.last_name}`}</Option>))}
          </Select>
          <Role allow={["admin"]} user={this.context.user}>
          <Button className="plus-btn-pop" htmlType='button' type="primary" onClick={this.showDrawer}>
            <i className="fa fa-plus" />
          </Button>
          </Role>
        </div>
        <div>
          <Drawer title="Add Contact" placement="right" onClose={this.onClose} visible={this.state.visible}
            className="floating-form" destroyOnClose={true}>
            <Form>
              <FormItem label="First Name">
                {getFieldDecorator('first_name', {
                  rules: [{ required: true, message: 'Please input first name' }],
                })(<Input placeholder="Enter first name" />)}
              </FormItem>
              <FormItem label="Last Name">
                {getFieldDecorator('last_name', {
                  rules: [{ required: true, message: 'Please input last name' }],
                })(<Input placeholder="Enter last name" />)}
              </FormItem>
              <FormItem label="Email">
                {getFieldDecorator('email', {
                  rules: [{ required: true, message: 'Please input email' }],
                })(<Input placeholder="Enter email"  />)}
              </FormItem>
              <FormItem label="Phone">
                {getFieldDecorator('phone', {
                  rules: [{ required: true, message: 'Please input Phone' }],
                })(<Input placeholder="Enter phone" />)}
              </FormItem>
                <FormItem label="Position">
                {getFieldDecorator('position', {
                  rules: [{ required: true, message: 'Please input Position' }],
                })(<TextArea placeholder="Enter position" />)}
              </FormItem>
            </Form>
            <Button type="primary" htmlType="button" onClick={this.handleDrawerSubmit}>Add Contact</Button>
          </Drawer>
        </div>
      </div>
    );
  }
}

export const ContactFilter = Form.create()(ContactFilterForm);


// WEBPACK FOOTER //
// ./src/filters/Contact.jsx